import api from './api'

export const getAccountStatement = async (params) => {
  const response = await api.post('/admin/reports/accountstatement', params)
  return response.data
}

// Naya statement — point_ledger se (login wale ki apni + settle ki hui entries)
export const getStatementV2 = async (params) => {
  const response = await api.post('/admin/reports/statementv2', params)
  return response.data
}

// Statement ki game row ke saamne Excel icon — us row ke peeche ke saare bets
// (casino round / sports market) reference ke 13-column CSV shape me
export const getStatementBetExport = async (params) => {
  const response = await api.post('/admin/reports/statementv2/bet-export', params)
  return response.data
}

// Statement ki game row par click — us row ke bets (Details modal)
export const getStatementBetDetail = async (params) => {
  const response = await api.post('/admin/reports/statementv2/bet-detail', params)
  return response.data
}

export const getUserWinLoss = async (params) => {
  const response = await api.post('/admin/reports/user-win-loss', params)
  return response.data
}

// point_ledger based category-wise report (CASINO/SPORTS/THIRD_PARTY/SPORTSBOOK)
export const getPointCategoryReport = async (params) => {
  const response = await api.post('/admin/reports/point-category-report', params)
  return response.data
}

export const getUserBetHistory = async (params) => {
  const response = await api.get('/admin/reports/user-bet-history', { params })
  return response.data
}

export const getLoginHistory = async (params) => {
  const response = await api.get('/admin/reports/login-history', { params })
  return response.data
}

export const getPasswordHistory = async (params) => {
  const response = await api.get('/admin/reports/password-history', { params })
  return response.data
}

export const getIpDetail = async (ip) => {
  const response = await api.get('/admin/ip-detail', { params: { ip } })
  return response.data
}
